import React, { type PropsWithChildren } from "react";

import styles from "./Card.module.css";

type CardProps = PropsWithChildren<{
	className?: string;
}>;

export const Card = ({ children, className = "" }: CardProps) => {
	const classNames = [styles.root, className].filter(Boolean).join(" ");

	return <div className={classNames}>{children}</div>;
};
